import React, { useState, useEffect } from "react";
import { Button, Checkbox, Form, Input, Select, InputNumber } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { allhealthdetails, addhealthnum } from "../../Redux/actions/NumHealth";
import { Card } from "antd";
import YearData from "../Number HealthPage/YearData";
import ChildYearData from "../Number HealthPage/ChildYearData";

export default function Healthmake({ setCurrent, current }) {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const history = useHistory();
  const healthnum = useSelector((state) => state?.healthdetail?.healthnum);
  const CusDeatail = useSelector((state) => state?.healthdetail?.cusInfo);
  const famlyDetail = useSelector(
    (state) => state?.healthdetail?.famdetail?.healthdetail
  );
  const HealthInput = useSelector(
    (state) => state?.healthdetail?.famdetail?.healthIn
  );
  const [isGrandMembersDisabled, setGMDisabled] = useState(false);
  const [isGrandMembersInLawDisabled, setGMILDisabled] = useState(false);
  const [isChildrenDisabled, setCDisabled] = useState(true);
  const [insuranceMembers, setInsuranceMembers] = useState([]);
  const [checkedMembers, setCheckedMembers] = useState(
    HealthInput?.members ? HealthInput?.members : []
  );
  const [checkedGrandMembers, setCheckedGrandMembers] = useState([]);
  const [sonsCount, setSonsCount] = useState(0);
  const [daughtersCount, setDaughtersCount] = useState(0);
  const [err, setErr] = useState(false);
  const [loading, setLoading] = useState(false);
  const [ArrayContains, setArrayContains] = useState(famlyDetail);

  // console.log(famlyDetail)

  // useEffect(() => {
  //   const hasSon = ArrayContains.some((member) => member?.relationship === "Son1" || member?.relationship === "Son2" || member?.relationship === "Daughter1");
  //   setCDisabled(!hasSon);
  // }, [ArrayContains]);

  const onFinishFailed = (values) => {
    console.log(values);
  };
  const onFinish = (values) => {
    console.log("values", values);
    setLoading(true);
    let sons = values.sonsCount ?? 0;
    let daughters = values.daughtersCount ?? 0;
    let total = sons + daughters;
    console.log(total);
    if (total > 4) {
      setErr(true);
      console.log("Err:");
    } else {
      setErr(false);
      let obj = [];
      if (values.members.includes("Son")) {
        for (let i = 1; i < values.sonsCount; i++) {
          values.members.push("Son");
        }
      }
      if (values.members.includes("Daughter")) {
        for (let i = 1; i < values.daughtersCount; i++) {
          values.members.push("Daughter");
        }
      }
      console.log(values);
      values.members.map((item, index) => {
        console.log(item, index);
        if (item === "Self") {
          obj.push({
            relationship: item,
            gender: CusDeatail.gender,
            age: values.selfage,
          });
        }
        if (item === "Spouse") {
          obj.push({
            relationship: item,
            gender: CusDeatail.gender === "male" ? "Female" : "Male",
            age: values.ageOfSpouce,
          });
        }
        // if (item === "Son") {
        //   obj.push({
        //     relationship: item,
        //     gender: "Male",
        //     age: 18,
        //   });
        // }
        // if (item === "Daughter") {
        //   obj.push({
        //     relationship: item,
        //     gender: "Female",
        //     age: 18,
        //   });
        // }
      });
      if (values.grandMembers) {
        values.grandMembers.map((item) => {
          console.log(item);
          obj.push({
            relationship: item,
            gender: item === "Mother" ? "Female" : "Male",
            age: item === "Mother" ? values.motherage : values?.fatherage,
          });
        });
      }

      if (values.grandMembersInLaw) {
        values.grandMembersInLaw.map((item) => {
          obj.push({
            relationship: item,
            gender: item === "MotherInLaw" ? "Female" : "Male",
            age:
              item === "MotherInLaw"
                ? values?.motherinlawage
                : values?.fatherinlawage,
          });
        });
      }
      if (values.Son1age) {
        obj.push({
          relationship: "Son1",
          gender: "Male",
          age: values.Son1age,
        });
      }
      if (values.Son2age) {
        obj.push({
          relationship: "Son2",
          gender: "Male",
          age: values.Son2age,
        });
      }
      if (values.Daughter1age) {
        obj.push({
          relationship: "Daughter1",
          gender: "Female",
          age: values.Daughter1age,
        });
      }
      if (values.Daughter2age) {
        obj.push({
          relationship: "Daughter2",
          gender: "Female",
          age: values.Daughter2age,
        });
      }
      console.log("Success:", obj);
      dispatch(
        allhealthdetails({
          healthdetail: obj,
          healthIn: values,
        })
      );
      setTimeout(() => {
        setLoading(false);
        setCurrent(current + 1);
      }, 1000);
      //console.log(setCurrent,current)
      //localStorage.setItem("healthdetail", JSON.stringify(obj));
      //history.push("/policystephealth");
    }
  };

  const onMemberChange = (checkedValues) => {
    console.log("checked = ", checkedValues);
    setCheckedMembers(checkedValues);
    // if (checkedValues.length === 0) {
    //   const updateHealth = {
    //     ...healthnum,
    //     initial: '',
    // };
    // dispatch(addhealthnum(updateHealth))
    // }
    if (checkedValues.includes("Self") || checkedValues.includes("Spouse")) {
      setCDisabled(false);
    } else {
      setCDisabled(true);
      form.resetFields(["members"]);
    }
  };

  const onGrandMemberChange = (checkedValues) => {
    console.log("checked = ", checkedValues);
    setCheckedGrandMembers(checkedValues);
    if (checkedValues.includes("Father") || checkedValues.includes("Mother")) {
      setGMILDisabled(true);
    }
    if (
      checkedValues.includes("FatherInLaw") ||
      checkedValues.includes("MotherInLaw")
    ) {
      setGMDisabled(true);
    }
    if (checkedValues.length === 0) {
      setGMDisabled(false);
      setGMILDisabled(false);
    }
  };
  const onGenderChange = (e) => {
    console.log("radio checked", e.target.value);
  };

  const onSonsChange = (e) => {
    console.log("Sons Count", e, new Array(e).fill(1));
    setSonsCount(e);
  };

  const onDaughtersChange = (e) => {
    console.log("Daughters Count", e);
    setDaughtersCount(e);
  };

  return (
    <>
      <div className="card-body" style={{ padding: "0px" }}>
        <div className="text-center">
          {err ? (
            <p style={{ color: "#f81d22" }} className="">
              You can add only upto 4 children
            </p>
          ) : null}
          <Form
            form={form}
            name="register"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
            className="healthform"
          >
            <div className="row justify-content-md-center">
              <div className="col-12">
                <div className="mb-2 mx-auto" style={{ maxWidth: "500px" }}>
                  <div className="card-body" style={{ padding: "0px" }}>
                    <Form.Item
                      name="members"
                      className="mb-0"
                      rules={[
                        {
                          required: true,
                          message: "Please select a member to insure",
                        },
                      ]}
                      initialValue={HealthInput?.members || []}
                    >
                      <Checkbox.Group
                        style={{ width: "100%" }}
                        onChange={onMemberChange}
                      >
                        <div className="d-flex justify-content-between align-items-center bg-light px-3 py-2 rounded mb-2">
                          <Checkbox value="Self">Self</Checkbox>
                          {checkedMembers.includes("Self") ? (
                            <Form.Item
                              className="mb-0"
                              style={{ width: "30%" }}
                              //label="Your Age"
                              name="selfage"
                              rules={[
                                {
                                  required: true,
                                  message: "",
                                },
                              ]}
                              initialValue={CusDeatail?.Age}
                            >
                              <Select
                                defaultValue="Select Age"
                                options={YearData?.map((p) => ({
                                  value: p?.value,
                                  label: p?.label,
                                }))}
                              />
                            </Form.Item>
                          ) : null}
                        </div>
                        <div className="d-flex justify-content-between align-items-center bg-light px-3 py-2 rounded mb-2">
                          <Checkbox value="Spouse">Spouse</Checkbox>
                          {checkedMembers.length >= 1 &&
                          checkedMembers.includes("Spouse") ? (
                            <Form.Item
                              className="mb-0"
                              style={{ width: "30%" }}
                              //label="Age of spouse"
                              name="ageOfSpouce"
                              rules={[
                                {
                                  required: true,
                                  message: "",
                                },
                              ]}
                              initialValue={HealthInput?.ageOfSpouce}
                            >
                              <Select
                                defaultValue="Select Age"
                                options={YearData?.map((p) => ({
                                  value: p?.value,
                                  label: p?.label,
                                }))}
                              />
                            </Form.Item>
                          ) : null}
                        </div>
                        <div className="d-block">
                          <div className="d-flex justify-content-between align-items-center bg-light px-3 py-2 rounded mb-2">
                            <Checkbox value="Son" disabled={isChildrenDisabled}>
                              Son
                            </Checkbox>
                            {checkedMembers.includes("Son") ? (
                              <Form.Item
                                className="mb-0"
                                label="No of Sons"
                                name="sonsCount"
                                rules={[
                                  {
                                    required: true,
                                    message: "",
                                  },
                                ]}
                                // initialValue={HealthInput?.sonsCount}
                              >
                                <InputNumber
                                  min={1}
                                  max={2}
                                  placeholder="Count"
                                  onChange={onSonsChange}
                                />
                              </Form.Item>
                            ) : null}
                          </div>
                          {checkedMembers.includes("Son") && !!sonsCount && (
                            <div className="d-flex justify-content-between flex-row align-items-center bg-light px-3 py-2 rounded mb-2">
                              {new Array(sonsCount).fill(1).map((x, i) => {
                                return (
                                  <Form.Item
                                    key={i}
                                    className="mb-2 me-0 me-md-2"
                                    // label={`Son ${i + 1}'s age`}
                                    name={`Son${i + 1}age`}
                                    rules={[
                                      {
                                        required: true,
                                        message: "",
                                      },
                                    ]}
                                    // initialValue={HealthInput?.Son1age}
                                  >
                                    <Select
                                      defaultValue={`Son ${i + 1}'s age`}
                                      options={ChildYearData?.map((p) => ({
                                        value: p?.value,
                                        label: p?.label,
                                      }))}
                                    />
                                  </Form.Item>
                                );
                              })}
                            </div>
                          )}
                        </div>
                        <div className="d-block">
                          <div className="d-flex justify-content-between align-items-center bg-light px-3 py-2 rounded mb-0">
                            <Checkbox
                              value="Daughter"
                              disabled={isChildrenDisabled}
                            >
                              Daughter
                            </Checkbox>
                            {checkedMembers.includes("Daughter") ? (
                              <Form.Item
                                className="mb-0"
                                label="No of Daughters"
                                name="daughtersCount"
                                rules={[
                                  {
                                    required: true,
                                    message: "",
                                  },
                                ]}
                                // initialValue={HealthInput?.daughtersCount}
                              >
                                <InputNumber
                                  min={1}
                                  max={2}
                                  placeholder="Count"
                                  onChange={onDaughtersChange}
                                />
                              </Form.Item>
                            ) : null}
                          </div>
                          {checkedMembers.includes("Daughter") &&
                            !!daughtersCount && (
                              <div className="d-flex justify-content-between flex-row align-items-center bg-light px-3 py-2 rounded mb-0">
                                {new Array(daughtersCount)
                                  .fill(1)
                                  .map((x, i) => {
                                    return (
                                      <Form.Item
                                        key={i}
                                        className="mb-2 me-0 me-md-2 text-right"
                                        // label={`Daughter ${i + 1}'s age`}
                                        name={`Daughter${i + 1}age`}
                                        rules={[
                                          {
                                            required: true,
                                            message: "",
                                          },
                                        ]}
                                        // initialValue={HealthInput?.Daughter1age}
                                      >
                                        <Select
                                          defaultValue={`Daughter ${
                                            i + 1
                                          }'s age`}
                                          options={ChildYearData?.map((p) => ({
                                            value: p?.value,
                                            label: p?.label,
                                          }))}
                                        />
                                      </Form.Item>
                                    );
                                  })}
                              </div>
                            )}
                        </div>
                      </Checkbox.Group>
                    </Form.Item>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="mx-auto" style={{ maxWidth: "500px" }}>
                  <div className="card-body" style={{ padding: "12px" }}>
                    <Form.Item
                      className="mb-0"
                      name="grandMembers"
                      // initialValue={HealthInput?.grandMembers || []}
                      // rules={[
                      //   {
                      //     required: !isGrandMembersDisabled,
                      //     message: "Please select a member to insure",
                      //   },
                      // ]}
                      rules={[
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            const isSelfSelected =
                              getFieldValue("members")?.includes("Self");
                            const GrandFatherLaw =
                              getFieldValue("grandMembersInLaw")?.includes(
                                "FatherInLaw"
                              );
                            const GrandMotherLaw =
                              getFieldValue("grandMembersInLaw")?.includes(
                                "MotherInLaw"
                              );
                            //console.log(GrandMembersLaw)
                            if (
                              isSelfSelected ||
                              GrandFatherLaw ||
                              GrandMotherLaw
                            ) {
                              return Promise.resolve(); // No validation needed if "Self" is selected
                            }

                            if (!value || value.length === 0) {
                              return Promise.reject(
                                "Please select a member to insure"
                              );
                            }

                            return Promise.resolve(); // Validation passes if other options are selected
                          },
                        }),
                      ]}
                    >
                      <Checkbox.Group
                        style={{ width: "100%" }}
                        onChange={onGrandMemberChange}
                      >
                        <div className="d-flex justify-content-between align-items-center bg-light px-3 py-2 rounded mb-2">
                          <Checkbox
                            value="Father"
                            disabled={isGrandMembersDisabled}
                          >
                            Father
                          </Checkbox>
                          {checkedGrandMembers.includes("Father") ? (
                            <Form.Item
                              className="mb-0"
                              label="Age"
                              name="fatherage"
                              rules={[
                                {
                                  required: true,
                                  message: "",
                                },
                              ]}
                              // initialValue={HealthInput?.fatherage}
                            >
                              {/* <InputNumber placeholder="Age" /> */}
                              <Select
                                defaultValue="Select Age"
                                options={YearData?.map((p) => ({
                                  value: p?.value,
                                  label: p?.label,
                                }))}
                              />
                            </Form.Item>
                          ) : null}
                        </div>
                        <div className="d-flex justify-content-between align-items-center bg-light px-3 py-2 rounded mb-0">
                          <Checkbox
                            value="Mother"
                            disabled={isGrandMembersDisabled}
                          >
                            Mother
                          </Checkbox>
                          {checkedGrandMembers.includes("Mother") ? (
                            <Form.Item
                              className="mb-0"
                              label="Age"
                              name="motherage"
                              rules={[
                                {
                                  required: true,
                                  message: "",
                                },
                              ]}
                              // initialValue={HealthInput?.motherage}
                            >
                              <Select
                                defaultValue="Select Age"
                                options={YearData?.map((p) => ({
                                  value: p?.value,
                                  label: p?.label,
                                }))}
                              />
                            </Form.Item>
                          ) : null}
                        </div>
                      </Checkbox.Group>
                    </Form.Item>
                    <p className="my-2">OR</p>
                    <Form.Item
                      name="grandMembersInLaw"
                      // rules={[
                      //   {
                      //     required: !isGrandMembersInLawDisabled,
                      //     message: "Please select a member to insure",
                      //   },
                      // ]}
                      rules={[
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            const isSelfSelected =
                              getFieldValue("members")?.includes("Self");
                            const GrandFather =
                              getFieldValue("grandMembers")?.includes("Father");
                            const GrandMother =
                              getFieldValue("grandMembers")?.includes("Mother");
                            //console.log(GrandMembers)
                            if (isSelfSelected || GrandFather || GrandMother) {
                              return Promise.resolve(); // No validation needed if "Self" is selected
                            }

                            if (!value || value.length === 0) {
                              return Promise.reject(
                                "Please select a member to insure"
                              );
                            }

                            return Promise.resolve(); // Validation passes if other options are selected
                          },
                        }),
                      ]}
                    >
                      <Checkbox.Group
                        style={{ width: "100%" }}
                        onChange={onGrandMemberChange}
                      >
                        <div className="d-flex justify-content-between align-items-center bg-light px-3 py-2 rounded mb-2">
                          <Checkbox
                            value="FatherInLaw"
                            disabled={isGrandMembersInLawDisabled}
                          >
                            Father In-Law
                          </Checkbox>
                          {checkedGrandMembers.includes("FatherInLaw") ? (
                            <Form.Item
                              className="mb-0"
                              label="Age"
                              name="fatherinlawage"
                              rules={[
                                {
                                  required: true,
                                  message: "",
                                },
                              ]}
                            >
                              <Select
                                defaultValue="Select Age"
                                options={YearData?.map((p) => ({
                                  value: p?.value,
                                  label: p?.label,
                                }))}
                              />
                            </Form.Item>
                          ) : null}
                        </div>
                        <div className="d-flex justify-content-between align-items-center bg-light px-3 py-2 rounded mb-0">
                          <Checkbox
                            value="MotherInLaw"
                            disabled={isGrandMembersInLawDisabled}
                          >
                            Mother In-Law
                          </Checkbox>
                          {checkedGrandMembers.includes("MotherInLaw") ? (
                            <Form.Item
                              className="mb-0"
                              label="Age"
                              name="motherinlawage"
                              rules={[
                                {
                                  required: true,
                                  message: "",
                                },
                              ]}
                            >
                              <Select
                                defaultValue="Select Age"
                                options={YearData?.map((p) => ({
                                  value: p?.value,
                                  label: p?.label,
                                }))}
                              />
                            </Form.Item>
                          ) : null}
                        </div>
                      </Checkbox.Group>
                    </Form.Item>
                  </div>
                </div>
              </div>
            </div>
            <Form.Item>
              <div className="step-btn-health">
                {current && current > 0 ? (
                  <Button
                    style={{ width: "40%" }}
                    //type="primary"
                    onClick={() => setCurrent(current - 1)}
                  >
                    Back
                  </Button>
                ) : null}
                <Button
                  loading={loading}
                  type="primary"
                  htmlType="submit"
                  style={{ width: "40%" }}
                >
                  Continue
                </Button>
              </div>
            </Form.Item>
          </Form>
        </div>
      </div>
    </>
  );
}
